<ng-container [ngComponentOutlet]="component" [ngComponentOutletInjector]="tempInjector"> </ng-container>
